export enum DirectEntryStepEnum {
    GeneralInfo = 1,
    FeesWaiversExemptions = 2,
    ApplicantInfo = 3,
    RegulatoryInfo = 4,
    CertificationInfo = 5,
    ScheduleHAdditionalInformation = 6,
    SchedulesDAndH = 7,
    AttachmentsAndWaivers = 8,
    ScheduleK = 9,
    // `SubmitToEwa` is not a real step as it does not run validations or store the validation state.
    //  It is used for submission only.
    SubmitToEwa = 10,
}

/**
 * Paths or partial uris that represent the steps in the direct entry application process.
 */
export const DirectEntryStepPaths = {
    generalInfo: 'general-info',
    feesWaiversExemptions: 'fees-waivers-exemptions',
    applicantInfo: 'applicant-info',
    regulatoryInfo: 'regulatory-info',
    certificationInfo: 'certification-info',
    scheduleK: 'schedule-k',
    scheduleHAdditionalInformation: 'schedule-h-additional-information',
    schedulesDAndH: 'schedules-d-and-h',
    attachmentsAndWaivers: 'attachments-and-waivers',
    submitToEwa: 'submit-to-ewa',
} as const;

/**
 * Mapping of the step paths to the step enum values.
 */
export const DirectEntryEnumToPathMapping = {
    [DirectEntryStepPaths.generalInfo]: DirectEntryStepEnum.GeneralInfo,
    [DirectEntryStepPaths.feesWaiversExemptions]:
        DirectEntryStepEnum.FeesWaiversExemptions,
    [DirectEntryStepPaths.applicantInfo]: DirectEntryStepEnum.ApplicantInfo,
    [DirectEntryStepPaths.regulatoryInfo]: DirectEntryStepEnum.RegulatoryInfo,
    [DirectEntryStepPaths.certificationInfo]:
        DirectEntryStepEnum.CertificationInfo,
    [DirectEntryStepPaths.scheduleHAdditionalInformation]:
        DirectEntryStepEnum.ScheduleHAdditionalInformation,
    [DirectEntryStepPaths.schedulesDAndH]: DirectEntryStepEnum.SchedulesDAndH,
    [DirectEntryStepPaths.attachmentsAndWaivers]:
        DirectEntryStepEnum.AttachmentsAndWaivers,
    [DirectEntryStepPaths.scheduleK]: DirectEntryStepEnum.ScheduleK,
    [DirectEntryStepPaths.submitToEwa]: DirectEntryStepEnum.SubmitToEwa,
} as const;
